export function exportToCSV(filename, data, columns) {
  if (!data || !data.length) {
    alert("No data available to export.");
    return;
  }

  const validColumns = columns || Object.keys(data[0]).map((k) => ({ key: k, header: k }));
  const headers = validColumns.map((col) => col.header || col.label || col.key || col.accessorKey).join(",");
  const rows = data.map((item) => {
    return validColumns
      .map((col) => {
        let val = item[col.key || col.accessorKey];
        if (val === undefined || val === null) return '""';
        if (typeof val === "object") {
          val = Array.isArray(val) ? `${val.length} items` : JSON.stringify(val);
        }
        val = String(val).replace(/"/g, '""');
        return `"${val}"`;
      })
      .join(",");
  });

  const csvContent = "\uFEFF" + [headers, ...rows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}_${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
